import Axios from "axios";

export const coingeckoTokenApi =
  "https://api.coingecko.com/api/v3/coins/ethereum";

const socketApiKey: string = process.env.NEXT_PUBLIC_SOCKET_API!;

// fetch Eth token price from coingecko
export const fetchTokensInfo = async (): Promise<number> => {
  try {
    const res = await Axios.get(coingeckoTokenApi);
    if (res && res.data) {
      return Number(res.data.market_data.current_price.usd);
    }
    return 0;
  } catch (e) {
    console.log(e, "error in fetch tokens");
    return 0;
  }
};

// socket quote for bridging ethereum tokens
export async function getSocketQuote(
  sourceChainId: number | string,
  destinationChainId: number | string,
  amount: string,
  userAddress: string,
  fromToken: string,
  toToken: string
) {
  try {
    console.log(
      sourceChainId,
      destinationChainId,
      amount,
      userAddress,
      fromToken,
      toToken,
      "eth getSocketQuote params"
    );
    let url = `https://api.socket.tech/v2/quote?fromTokenAddress=${fromToken}&fromChainId=${sourceChainId}&toTokenAddress=${toToken}&toChainId=${destinationChainId}&fromAmount=${amount}&userAddress=${userAddress}&recipient=${userAddress}&singleTxOnly=false&bridgeWithGas=false&defaultSwapSlippage=1&sort=output`;
    console.log(url, "getSocketQuote url");
    const response = await Axios.get(url, {
      headers: {
        "API-KEY": socketApiKey,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    console.log(response, "getSocketQuote response");
    if (response.data.success) {
      return response.data.result;
    } else {
      return {};
    }
  } catch (err) {
    return {};
  }
}

export async function buildSocketTx(route: any) {
  try {
    const url = `https://api.socket.tech/v2/build-tx`;
    const body = JSON.stringify({ route: route });
    const response = await Axios.post(url, body, {
      headers: {
        "api-key": socketApiKey,
        "Content-Type": "application/json",
      },
    });
    if (response.data.success) {
      return response.data.result;
    } else {
      throw new Error("No response from Socket API");
    }
  } catch (err) {
    throw new Error("Error in Socket API");
  }
}

// GET request to check token allowance given to allowanceTarget by owner
export async function checkAllowance(
  chainId,
  owner,
  allowanceTarget,
  tokenAddress
) {
  const response = await fetch(
    `https://api.socket.tech/v2/approval/check-allowance?chainID=${chainId}&owner=${owner}&allowanceTarget=${allowanceTarget}&tokenAddress=${tokenAddress}`,
    {
      method: "GET",
      headers: {
        "API-KEY": socketApiKey,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  const json = await response.json();
  return json;
}

// Fetches transaction data for token approval
export async function getApprovalTransactionData(
  chainId,
  owner,
  allowanceTarget,
  tokenAddress,
  amount
) {
  const response = await fetch(
    `https://api.socket.tech/v2/approval/build-tx?chainID=${chainId}&owner=${owner}&allowanceTarget=${allowanceTarget}&tokenAddress=${tokenAddress}&amount=${amount}`,
    {
      method: "GET",
      headers: {
        "API-KEY": socketApiKey,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  const json = await response.json();
  return json;
}
